import React from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import Logo from './Logo';
import LoggedInCookies from './LoggedInCookies';
var Footer = function Footer(_ref) {
  var filingIcon = _ref.filingIcon,
    footerLinks = _ref.footerLinks,
    pngLogoImage = _ref.pngLogoImage,
    socialMediaLinks = _ref.socialMediaLinks,
    svgLogoImage = _ref.svgLogoImage;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  return /*#__PURE__*/React.createElement("footer", null, /*#__PURE__*/React.createElement(LoggedInCookies, null), /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto g-padding"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-md-flex d-lg-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("h1", {
    className: "rubriq-plans-header fw-normal my-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "rubriq.footer-text"
  })), /*#__PURE__*/React.createElement(Logo, {
    className: "footer-brand",
    fallbackImage: pngLogoImage,
    image: svgLogoImage
  })), /*#__PURE__*/React.createElement("hr", {
    className: "my-5 border-0 border-top border-dark mt-0"
  }), /*#__PURE__*/React.createElement("div", {
    className: "row align-items-end"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-12 col-md-2 col-xl-2"
  }, footerLinks.left.map(function (_ref2) {
    var title = _ref2.title,
      links = _ref2.links;
    return /*#__PURE__*/React.createElement("div", {
      key: title
    }, /*#__PURE__*/React.createElement("h4", {
      className: "mb-4"
    }, /*#__PURE__*/React.createElement(T, {
      source: title
    })), /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    }, links.map(function (_ref3) {
      var title = _ref3.title,
        url = _ref3.url;
      return /*#__PURE__*/React.createElement("li", {
        key: url,
        className: "footer-link"
      }, /*#__PURE__*/React.createElement("a", {
        href: url,
        "aria-label": t(title)
      }, /*#__PURE__*/React.createElement(T, {
        source: title
      })));
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-sm-12 col-md-2 col-xl-2"
  }, footerLinks.right.map(function (_ref4) {
    var title = _ref4.title,
      links = _ref4.links;
    return /*#__PURE__*/React.createElement("div", {
      key: title
    }, /*#__PURE__*/React.createElement("h4", {
      className: "mb-4"
    }, /*#__PURE__*/React.createElement(T, {
      source: title
    })), /*#__PURE__*/React.createElement("ul", {
      className: "list-unstyled"
    }, links.map(function (_ref5) {
      var title = _ref5.title,
        url = _ref5.url;
      return /*#__PURE__*/React.createElement("li", {
        key: url,
        className: "footer-link"
      }, /*#__PURE__*/React.createElement("a", {
        href: url,
        "aria-label": t(title)
      }, /*#__PURE__*/React.createElement(T, {
        source: title
      })));
    })));
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-xs-12 col-md-6 ms-auto text-sm-start text-md-end"
  }, /*#__PURE__*/React.createElement("p", {
    className: "social-links mb-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex gap-3 justify-content-md-end justify-content-xl-end"
  }, socialMediaLinks.map(function (_ref6) {
    var img = _ref6.img,
      title = _ref6.title,
      url = _ref6.url;
    return /*#__PURE__*/React.createElement("div", {
      key: title,
      className: "d-flex align-items-center justify-content-center rounded",
      style: {
        height: '32px',
        width: '32px',
        backgroundColor: '#043842'
      }
    }, /*#__PURE__*/React.createElement("a", {
      target: "_blank",
      rel: "noopener noreferrer",
      href: url,
      title: t(title)
    }, /*#__PURE__*/React.createElement("img", {
      alt: t(title),
      height: "24",
      width: "24",
      src: img,
      loading: "lazy"
    })));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "small text-muted w-100"
  }, /*#__PURE__*/React.createElement(T.md, {
    source: "footer-copyright-new",
    params: {
      year: new Date().getFullYear(),
      icon: filingIcon
    }
  }))))));
};
export default Footer;